import React from 'react';  
import './index.css';
import { WingBlank } from 'antd-mobile'; 
 
class ReportScorePoint extends React.Component{
  render(){
    const {data} =this.props;
  
    return (
      <div className="report-item">
        <p className="report-title">评分点 </p>
        <WingBlank>
        {
          data&&data.size!=0?
          data.map((item,index)=>{
            return (
            <p key={index}>{index+1}.{item.get('point')}(<span>{item.get('ratio')}</span>)</p>
            )
          }):
          '暂无'
        }
          
         
        </WingBlank>
      </div>
      )
  }
}
export default ReportScorePoint;